import { Suspense, useEffect } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { Outlet, useLocation } from 'react-router-dom'
import classNames from 'classnames'

import { Loader } from '@foxino/components-web'

import { SnowParticles } from '@app/components'
import { basicLayoutStore } from '@app/modules/learningPlan/store/basicLayoutStore'
import { dialogStateStore } from '@app/modules/learningPlan/store/dialogStateStore'
import { SettingsDialog } from '@app/modules/settings/view/SettingsDialog/SettingsDialog'
import { LogUtils } from '@app/utils/LogUtils'

import { eggStore } from '../../store/eggStore'
import { sideNavigationStore } from '../../store/sideNavigationStore'
import { SideNavigation } from '../SideNavigation'

import 'swiper/swiper-bundle.css'

export const BasicLayout = () => {
  const location = useLocation()
  const { isTopBlurVisible, topBlurColor } = basicLayoutStore.useStore(({ isTopBlurVisible, topBlurColor }) => ({
    isTopBlurVisible,
    topBlurColor
  }))
  const { isSnowVisible } = eggStore.useStore(({ isSnowVisible }) => ({ isSnowVisible }))
  const isSettingsDialogOpen = dialogStateStore.useStore(({ settings }) => settings.isOpen)
  const { isSideNavigationOpen, isSideNavigationHidden } = sideNavigationStore.useStore(({ isOpen, isHidden }) => ({
    isSideNavigationOpen: isOpen,
    isSideNavigationHidden: isHidden
  }))

  useEffect(() => {
    LogUtils.logScreenView(location.pathname)
  }, [location])

  useEffect(() => {
    if (isMobileOnly) {
      const viewportMetaTag = document.querySelector('meta[name="viewport"]')
      if (viewportMetaTag) {
        viewportMetaTag.setAttribute('content', 'width=device-width, initial-scale=0.6, maximum-scale=0.8')
      } else {
        const newViewportMetaTag = document.createElement('meta')
        newViewportMetaTag.setAttribute('name', 'viewport')
        newViewportMetaTag.setAttribute('content', 'width=device-width, initial-scale=0.6, maximum-scale=0.8')
        document.head.appendChild(newViewportMetaTag)
      }
    }
  }, [])

  return (
    <Suspense
      fallback={
        <div className="text-pr flex h-screen w-screen items-center justify-center">
          <Loader />
        </div>
      }
    >
      {isSnowVisible && <SnowParticles />}

      <div className="relative flex w-full text-white antialiased">
        <main className="flex w-full text-white">
          <>
            {isSideNavigationOpen && <SideNavigation />}

            <div
              className={classNames(
                'relative h-full',
                isSideNavigationOpen && !isSideNavigationHidden ? 'w-[calc(100%-4.4rem)]' : 'w-full'
              )}
            >
              {isTopBlurVisible && (
                <div
                  style={{ background: topBlurColor }}
                  className="flex w-[530px] max-w-[90vw] items-center gap-2 md:gap-4"
                >
                  <div className="absolute -top-40 left-1/2 h-60 w-96 flex-shrink-0 -translate-x-1/2 rounded-full bg-[#6153D0] opacity-30 blur-[125px]" />
                </div>
              )}

              {isSettingsDialogOpen && <SettingsDialog onClose={() => dialogStateStore.setIsClosed('settings')} />}
              <Suspense fallback={<div />}>
                <Outlet />
              </Suspense>
            </div>
          </>
        </main>
      </div>
    </Suspense>
  )
}
